import React, { useState, useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "./NavBarV2.scss";

export default function NavBarV2(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [navActiveLink, setNavActiveLink] = useState("default");
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setNavActiveLink(location.pathname);
  }, [location]);

  useEffect(() => {
    if (props.navActiveLink) {
      setNavActiveLink(props.navActiveLink);
    }
  }, [props.navActiveLink]);

  const handleNavClick = (targetPath, targetSectionId) => {
    setExpanded(false);
    if (location.pathname === "/" || location.pathname.startsWith("/home")) {
      const el = document.getElementById(targetSectionId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate(targetPath);
      }
    } else {
      navigate(targetPath);
    }
  };

  return (
    <div className="navigation">
      <div className="container">
        <Navbar
          expand="lg"
          variant="dark"
          className="px-0"
          expanded={expanded}
          onToggle={setExpanded}
        >
          <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
            <div className="logo">
              <img
                width="40"
                height="32"
                src={props.logo}
                alt="Woodlands Digital Technologies Logo"
              />
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav activeKey={navActiveLink} className="ms-auto my-2 my-lg-0">
              <Nav.Link
                id="nav-home"
                as={Link}
                to="/"
                onClick={() => {
                  setExpanded(false);
                  if (location.pathname === "/" || location.pathname.startsWith("/home")) {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }
                }}
                active={navActiveLink === "/" || navActiveLink === "/home"}
              >
                Home
              </Nav.Link>
              <Nav.Link
                id="nav-about"
                as={Link}
                to="/home/about"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("/home/about", "about");
                }}
                active={navActiveLink === "/home/about"}
              >
                About
              </Nav.Link>
              <Nav.Link
                id="nav-services"
                as={Link}
                to="/home/services"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("/home/services", "services");
                }}
                active={navActiveLink === "/home/services"}
              >
                Services
              </Nav.Link>
              <Nav.Link
                id="nav-free-consultation"
                as={Link}
                to="/home/consultation"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("/home/consultation", "consultation");
                }}
                active={navActiveLink === "/home/consultation"}
              >
                Free Consultation
              </Nav.Link>
              <Nav.Link
                id="nav-portfolio"
                as={Link}
                to="/home/portfolio"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("/home/portfolio", "portfolio");
                }}
                active={navActiveLink === "/home/portfolio"}
              >
                Portfolio
              </Nav.Link>
              <Nav.Link
                id="nav-contact-us"
                as={Link}
                to="/home/contact"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("/home/contact", "contact");
                }}
                active={navActiveLink === "/home/contact"}
              >
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    </div>
  );
}
